import type { getUniqueRevCodesQuery } from "../../remote/gql/graphql";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { getUniqueRevCodesQueryDoc } from "../../remote/queries/getUniqueRevCodes.gql";
import { AlaffiaClientModule } from "./modules";

type RevCodesModuleArgs = AlaffiaClientModuleArgs;

export class RevCodesModule extends AlaffiaClientModule {
  constructor(args: RevCodesModuleArgs) {
    super(args);
  }

  getUniqueRevCodes = async (input: {
    includes: string;
  }): ClientReturnType<getUniqueRevCodesQuery["uniqueRevCodes"]> => {
    const result = await this.runGqlQuery(
      getUniqueRevCodesQueryDoc,
      { includes: input.includes },
      "getUniqueRevCodes",
    );

    return {
      data: result.data?.uniqueRevCodes ?? null,
      error: result.error ?? null,
    };
  };
}
